import { AdvancedFilterInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import * as z from "zod/v4";

export const countPrintJobs = {
  name: "countPrintJobs" as const,
  input: AdvancedFilterInputSchema,
  output: z.number(),
};

export type CountPrintJobsInput = z.infer<typeof countPrintJobs.input>;
